<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台产品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrapper">
      <ul>
        <li v-for="p in platformList" :key="p.id" class="platform_item">
          <div class="platform_left">
            <img
              :src="p.cover"
              :alt="p.title"
              class="platform_pic"
            />
          </div>
          <div class="platform_center">
            <p class="platform_title">{{ p.title }}</p>
            <p>{{ p.date }}</p>
          </div>
          <div class="platform_right">
            <el-button plain @click="gotoDeatil(p.id)">查看详情</el-button>
          </div>
        </li>
      </ul>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]" :page-size="5" layout="total, sizes, prev, pager, next, jumper" :total="total"
            background>
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import requests from "@/api/request";
export default {
  name: "PlatFormListView",
  data() {
    return {
      platformList: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
    };
  },
  mounted() {
    this.getPlatformList(this.currentPage, this.pageSize);
    this.isFirst = 0;
  },
  methods:{
    // 分页获取数据
    async getPlatformList(page, pageSize) {
      return requests({
        url: "/products/showProductPages?page=" + page + "&pageSize=" + pageSize,
        method: "GET"
      }).then(res => {
        console.log('getNewsListres', res.data);
        this.platformList.splice(0, this.platformList.length);
        this.total = res.data.counts;
        let d = res.data.items;
        d.forEach((item, i) => {
          this.platformList.push(d[i]);
          this.$set(this.platformList[i], 'date', d[i].createTime.substring(0, 10));
        });
        // console.log('this.NewsList',this.NewsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getNewsList(this.currentPage, this.pageSize);
    },
    // 调整页数
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getNewsList(this.currentPage, this.pageSize);
    },
    // 详情
    gotoDeatil(platformId) {
      this.$router.push({ name: 'platformDetail', query: { platformId: platformId } })
    }
  }
};
</script>

<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.content_wrapper {
  border: #a8a4a4 solid 1px;
  padding: 40px;
  margin-bottom: 20px;
  min-height: calc(100vh - 220px);
}

.content_wrapper ul {
  margin: 0;
  padding: 0;
}
.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}
.platform_item {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  border: #a8a4a4 solid 1px;
  height: 120px;
}
.platform_left,
.platform_right {
  width: 200px;
}
.platform_pic {
  height: 100%;
  width: 100%;
}
.platform_center {
  width: 640px;
  text-align: left;
}
.platform_title {
  font-size: large;
}
.platform_right {
  margin: 10px 0;
  padding-top: 30px;
  border-left: solid 1px #63065f;
}

.pagination {
  margin-top: 40px;
  margin-bottom: 30px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #63065f;
}
</style>
